import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AccountInfoInitialState, AccountInfoTypes } from './account.state.ts';
import { IUserPortal } from 'interfaces/UserAccountInfo.interface.ts';
import { RoutePaths } from '@/common/enum';
import { IReceptionExtended } from 'hooks/useLoginForm';

const initialState: AccountInfoTypes = AccountInfoInitialState;

export const accountSlice = createSlice({
  name: 'account',
  initialState,
  reducers: {
    SET_ACCOUNT: (state, action: PayloadAction<Partial<IUserPortal>>) => {
      state.account = action.payload;
      state.selectedGroup = String(action.payload.pvActiveGroupID);
      const userAccountsInfo = action.payload;
      const activeCurrentGroup =
        userAccountsInfo?.currentGroups &&
        userAccountsInfo.currentGroups.length &&
        userAccountsInfo.currentGroups.find(
          (group) => group.i === userAccountsInfo.pvActiveGroupID
        );
      state.selectedGroupName =
        activeCurrentGroup && activeCurrentGroup.n ? activeCurrentGroup.n : null;
    },
    SET_ACTIVE_PATH: (state, action: PayloadAction<RoutePaths>) => {
      state.sideMenuActivePath = action.payload;
    },
    SET_RECEPTION_CENTER: (state, action: PayloadAction<IReceptionExtended>) => {
      state.selectedReceptionCenter = action.payload;
    },
  },
});

export default accountSlice.reducer;
